import { useState } from "react";
import { cn } from "@/lib/utils";
import { X, Info, AlertTriangle, AlertCircle, CheckCircle } from "lucide-react";

const variantConfig = {
  info: { 
    icon: Info, 
    bg: 'bg-electric-ice-blue/10 border-electric-ice-blue/30',
    iconColor: 'text-electric-ice-blue',
    textColor: 'text-electric-ice-blue'
  },
  warning: { 
    icon: AlertTriangle, 
    bg: 'bg-soft-amber/10 border-soft-amber/30',
    iconColor: 'text-soft-amber',
    textColor: 'text-soft-amber'
  },
  error: { 
    icon: AlertCircle, 
    bg: 'bg-signal-red/10 border-signal-red/30',
    iconColor: 'text-signal-red',
    textColor: 'text-signal-red'
  },
  success: { 
    icon: CheckCircle, 
    bg: 'bg-cool-mint/10 border-cool-mint/30',
    iconColor: 'text-cool-mint',
    textColor: 'text-cool-mint'
  },
};

export const AlertBanner = ({ 
  variant = 'info',
  title,
  message,
  dismissible = true,
  onDismiss,
  className 
}) => {
  const [isVisible, setIsVisible] = useState(true);
  const config = variantConfig[variant];
  const Icon = config.icon;
  
  const handleDismiss = () => {
    setIsVisible(false);
    onDismiss?.();
  };
  
  if (!isVisible) return null;
  
  return (
    <div 
      className={cn(
        "flex items-start gap-3 p-4 rounded-xl border",
        config.bg,
        className
      )}
      data-testid="alert-banner"
      role="alert"
    >
      <Icon className={cn("w-5 h-5 flex-shrink-0 mt-0.5", config.iconColor)} />
      
      <div className="flex-1 min-w-0">
        {title && (
          <h4 className={cn("font-medium mb-1", config.textColor)}>
            {title}
          </h4>
        )}
        <p className="text-sm text-soft-silver">{message}</p>
      </div>
      
      {dismissible && (
        <button
          onClick={handleDismiss}
          className="p-1 rounded hover:bg-white/[0.1] transition-colors"
          data-testid="alert-dismiss"
        >
          <X className="w-4 h-4 text-soft-silver" />
        </button>
      )}
    </div>
  );
};

export default AlertBanner;
